<template>
  <div>
    <blocks-home :kauri="this.kauri" :pohutukawa="this.pohutukawa" />
    <div class="title-line-base"><h5 class="title-line">Last Entries</h5></div>
    <ul class="group-card-last-entries">
      <li v-for="(plant, index) in plants.slice(0, 4)" v-bind:key="index">
        <card-plant :plant="plant" />
      </li>
    </ul>
    <div class="title-line-base"><h5 class="title-line">Categories</h5></div>
    <ul class="group-card-categories">
      <li v-for="(entry, index) in categories" v-bind:key="index">
        <card-category
          :src="entry.src"
          :title="entry.title"
          :link="entry.link"
        />
      </li>
    </ul>
  </div>
</template>
<script>
import CardPlant from "../Cards/CardPlant.vue";
import CardCategory from "../Cards/CardCategory.vue";
import PlantService from "@/services/PlantService.js";
import BlocksHome from "./BlocksHome.vue";

export default {
  name: "PanelHome",
  components: {
    CardPlant,
    CardCategory,
    BlocksHome,
  },
  props: {},
  data() {
    return {
      plants: [],
      categories: [
        { src: "paradis-bird.jpg", title: "Flower", link: "/category/flower" },
        { src: "fern-home.jpg", title: "Fern", link: "/category/fern" },
        { src: "ibiscus.jpg", title: "Tree", link: "/category/tree" },
        { src: "grass-home.jpg", title: "Grass", link: "/category/grass" },
      ],
      pohutukawa: undefined,
      kauri: undefined,
    };
  },
  created() {
    this.fetchDataPlants();
  },
  methods: {
    async fetchDataPlants() {
      PlantService.getPlants()
        .then((res) => {
          this.plants = res;
          this.pohutukawa = res.find((plant) => plant.name === "Pohutukawa");
          this.kauri = res.find((plant) => plant.name === "Kauri");
        })
        .finally(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.title-line-base {
  text-align: center;
  position: relative;
  margin: 0px 0px 20px;
}
.title-line-base::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 50%;
  width: 100%;
  border-top: 4px solid $color-primary;
  margin-top: -2px;
}
.title-line {
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 0px;
  margin-top: 0px;
  position: relative;
  background: rgb(255, 255, 255) none repeat scroll 0% 0%;
}
.group-card-last-entries {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  list-style: none;
  @media (min-width: $constraint-width-small) {
    grid-gap: 36px;
  }
}
.group-card-categories {
  @media (min-width: $constraint-width-small) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.group-card-categories > li {
  margin: 5px;
}
.group-card-last-entries > li {
  margin: 0px;
}
.group-card.categories > li:first-child,
.group-card-last-entries > li:first-child {
  margin-left: 0;
}
.group-card.categories > li:last-child,
.group-card-last-entries > li:last-child {
  margin-right: 0;
}
</style>
